import DynamicFieldsSerializer from '@linc-technologies/linced-common/serializers/dynamic-fields';

export default class Application extends DynamicFieldsSerializer {
  namespace = 'enrolments';
}
